import { damageKeys } from "./keys";
export const yesNo = [
  { text: "YES", value: true },
  { text: "NO", value: false },
];

export const yesNoNA = ["Yes", "No", "N/A"];

export const yesNoUnsure = [
  { text: "YES", value: "YES" },
  { text: "UNSURE", value: "UNSURE" },
  { text: "NO", value: "NO"}
];

export const gender = ["Male", "Female", "Unknown"];

export const maritalStatus = [
  "Divorced",
  "Married",
  "Separated",
  "Single",
  "Unknown",
  "Widowed",
];

export const employmentStatusGW = [
  "Disabled",
  "Full-time apprentice",
  "Full-time employee",
  "On strike",
  "Part-time employee",
  "Part-time apprentice",
  "Pieceworker",
  "Retired",
  "Seasonal",
  "Unemployed",
  "Volunteer",
  "Other",
];

export const wagePer = ["Week", "Hour", "Year"];

export const payPeriod = [
  "Daily",
  "Every two weeks",
  "Monthly",
  "Twice a month",
  "Weekly",
];

export const transportation = [
  "Third party",
  "Air",
  "Ambulance",
  "Drove Self",
  "Unknown",
  "None",
];

export const duty = ["Full duty", "Light duty"];

export const vehicleLocationType = [
  "Residence",
  "Business/Work",
  "Tow Yard",
  "Body Shop",
  "Impound",
];

export const BehalfOfOptions = ["The Insured", "Third-party claimant"];

export const documentDelivery = ["Email", "Mail", "No Correspondence"];

export const phoneType = ["Mobile", "Home", "Work"];

export const vehicleMakes = [
  { code: "ACUR", name: "Acura" },
  { code: "ALFA", name: "Alfa Romeo" },
  { code: "ALIE", name: "Allied" },
  { code: "ALIS", name: "Allis-Chalmers" },
  { code: "ALKO", name: "Alois Kober (AL-KO)" },
  { code: "ALUE", name: "Alouette Recreational Products, Ltd." },
  { code: "AMGN", name: "AM General Corp (Hummer)" },
  { code: "ARCA", name: "Arctic Cat" },
  { code: "ARCC", name: "Arctic Enterprises" },
  { code: "ARLB", name: "Arlberg" },
  { code: "ASTO", name: "Aston Martin" },
  { code: "AUDI", name: "Audi" },
  { code: "AUTS", name: "Auto Ski, Inc." },
  { code: "BENT", name: "Bentley" },
  { code: "BMW", name: "BMW" },
  { code: "BOAS", name: "Boa-Ski Airport, Ltd." },
  { code: "BOAT", name: "Boatel Ski" },
  { code: "BOMB", name: "Bombardier" },
  { code: "BMBR", name: "Bombardier, Inc." },
  { code: "BRUZ", name: "Brutanza Engineering, Inc." },
  { code: "BUIC", name: "Buick" },
  { code: "CADI", name: "Cadillac" },
  { code: "CHPR", name: "Chaparral Inds, Inc." },
  { code: "CHEV", name: "Chevrolet" },
  { code: "CHRY", name: "Chrysler" },
  { code: "CHOC", name: "Chrysler Outboard Corp." },
  { code: "CITR", name: "Citroen" },
  { code: "CSHM", name: "Cushman" },
  { code: "DAEW", name: "Daewoo" },
  { code: "DAIH", name: "Daihatsu" },
  { code: "DATS", name: "Datsun" },
  { code: "DAUP", name: "Dauphin" },
  { code: "JDER", name: "Deere & Co." },
  { code: "DODG", name: "Dodge" },
  { code: "FEMC", name: "Feldman Engineering & Mfg., Co." },
  { code: "FERR", name: "Ferrari" },
  { code: "FIAT", name: "Fiat" },
  { code: "FORD", name: "Ford" },
  { code: "FRED", name: "Frederick-Willys" },
  { code: "GM", name: "General Motors" },
  { code: "GMC", name: "General Motors Corp." },
  { code: "GEO", name: "GEO" },
  { code: "GBCO", name: "Gilson Brothers Co." },
  { code: "RPII", name: "H & H Snowmobiles" },
  { code: "HDMC", name: "Harley-Davidson Motor Co., Inc." },
  { code: "HRTI", name: "Herters, Inc." },
  { code: "HOND", name: "Honda" },
  { code: "HURU", name: "Hustler-Rustler" },
  { code: "HYUN", name: "Hyundai" },
  { code: "INFI", name: "Infiniti" },
  { code: "ISU", name: "Isuzu" },
  { code: "JACC", name: "Jac-Trac, Inc." },
  { code: "JAGU", name: "Jaguar" },
  { code: "KAWK", name: "Kawasaki" },
  { code: "KMCU", name: "Kawasaki Motors Corp., USA" },
  { code: "KIA", name: "Kia Motors Corp." },
  { code: "LAMO", name: "Lamborghini" },
  { code: "LNDR", name: "Land Rover" },
  { code: "LARV", name: "Larvin" },
  { code: "RAID", name: "Leisure Vehicles, Inc." },
  { code: "LEXS", name: "Lexus" },
  { code: "LINC", name: "Lincoln-Continental" },
  { code: "LIOL", name: "Lional Enterprises, Inc." },
  { code: "LSKP", name: "Lori Engineering Corp." },
  { code: "LOTU", name: "Lotus" },
  { code: "MALR", name: "Mallard" },
  { code: "MASE", name: "Maserati" },
  { code: "MSFI", name: "Massey-Ferguson, Inc." },
  { code: "MAYB", name: "Maybach" },
  { code: "MAZD", name: "Mazda" },
  { code: "MERZ", name: "Mercedes-Benz" },
  { code: "MERC", name: "Mercury" },
  { code: "MRCU", name: "Mercury Marine" },
  { code: "MG", name: "MG" },
  { code: "MITS", name: "Mitsubishi" },
  { code: "MOWA", name: "Montgomery Ward" },
  { code: "KOME", name: "Moto Kometik, Inc." },
  { code: "NISS", name: "Nissan" },
  { code: "NRTS", name: "Northway Snowmobiles" },
  { code: "OCKE", name: "Ockelbo Ind. AB" },
  { code: "OLDS", name: "Oldsmobile" },
  { code: "ODGL", name: "Ontario Drive & Gear, Ltd." },
  { code: "ORIG", name: "Original Equipment Mfg, Ltd." },
  { code: "ATV", name: "Other ATV" },
  { code: "OUTM", name: "Outboard Marine Corp." },
  { code: "OTPE", name: "Outdoor Power Equipment" },
  { code: "PANH", name: "Panhard" },
  { code: "PEUG", name: "Peugeot" },
  { code: "PLYC", name: "Playcat Inds, Inc." },
  { code: "PLYM", name: "Plymouth" },
  { code: "POLS", name: "Polaris Inds., Inc" },
  { code: "PLRN", name: "Poloron" },
  { code: "PONT", name: "Pontiac" },
  { code: "PORS", name: "Porsche" },
  { code: "POLB", name: "Raybon Mfg. Co." },
  { code: "RENA", name: "Renault" },
  { code: "ROLF", name: "Roll-O-Flex, Ltd." },
  { code: "ROL", name: "Rolls-Royce" },
  { code: "SAA", name: "Saab" },
  { code: "STRN", name: "Saturn" },
  { code: "SCRP", name: "Scorpion, Inc." },
  { code: "SRCO", name: "Sears" },
  { code: "SKIR", name: "Skiroule, Ltd." },
  { code: "SNOJ", name: "Sno*Jet, Inc." },
  { code: "SNOW", name: "Snowmobile" },
  { code: "SPPI", name: "Speedway Products, Inc." },
  { code: "STCO", name: "Starcraft Corp." },
  { code: "SUBA", name: "Subaru" },
  { code: "SUZI", name: "Suzuki" },
  { code: "SUZU", name: "Suzulight Su" },
  { code: "TTII", name: "T & T Inds., Inc." },
  { code: "MNTA", name: "Three R Inds., Inc." },
  { code: "TOYT", name: "Toyota" },
  { code: "TRIU", name: "Triumph" },
  { code: "TSCC", name: "Tucker Sno-Cat Corp." },
  { code: "USSM", name: "U.S. Suzuki Motor Corp., Ltd." },
  { code: "VKNG", name: "Viking Snowmobiles, Inc." },
  { code: "VOLK", name: "Volkswagen" },
  { code: "VOLV", name: "Volvo" },
  { code: "YAMA", name: "Yamaha" },
  { code: "YMCL", name: "Yamaha Motor Co., Ltd." },
  { code: "ZCZY", name: "Zastavia (ZCZ-Yugoslavia)" },
];

export const damageTypes = [
  { label: "The insured", value: damageKeys.Property },
  { label: "Another party", value: damageKeys.Liability },
  {
    label: "The insured and another party",
    value: damageKeys.Liability,
  },
];

export const userTypes = [
  { text: "the Insured", value: "the Insured" },
  { text: "an Agent", value: "an Agent" },
  { text: "a Third Party", value: "a Third Party" },
];

export const vehicleOwnerOptions = [
  { text: "Listed on policy", value: "Listed on policy" },
  { text: "Rental", value: "Rental" },
  { text: "Another Owner", value: "Another Owner"}
];
